(function(){

let CUSTOMER_ID = null;

try{
  CUSTOMER_ID = window.ShopifyAnalytics?.meta?.page?.customerId || null;
}catch(e){}

/* session id */

let session_id = localStorage.getItem("ut_session");

if(!session_id){
  session_id = crypto.randomUUID();
  localStorage.setItem("ut_session", session_id);
}

async function getCart(){
  return await fetch("/cart.js").then(r => r.json());
}

async function waitForCartChange(oldCount, retries = 10){

  for(let i=0;i<retries;i++){

    const cart = await getCart();

    if(cart.item_count !== oldCount){
      return cart;
    }

    await new Promise(r => setTimeout(r,150));
  }

  return await getCart();
}

async function sendCartAnalytics(eventType){

  try{

    const cart = await getCart();

    const payload = {
      timestamp: Date.now(),
      session_id: session_id,
      cart_token: cart.token,
      customer_id: CUSTOMER_ID,
      event_type: eventType,
      items: cart.items.map(i => ({
        handle: i.handle,
        variant_id: i.variant_id,
        qty: i.quantity,
        price: i.price,
        title: i.product_title
      }))
    };

    fetch("https://shop-khangdopane.viveksaikhom.workers.dev",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body: JSON.stringify(payload)
    });

  }catch(e){}

}

document.addEventListener("click", async function(e){

  const buyNowButton = e.target.closest(".shopify-payment-button__button");

  if(buyNowButton){
    sendCartAnalytics("buy_now");
    return;
  }

  const addButton = e.target.closest('[name="add"], button[type="submit"]');

  if(addButton){

    const oldCart = await getCart();

    const updatedCart = await waitForCartChange(oldCart.item_count);

    const payload = {
      timestamp: Date.now(),
      session_id: session_id,
      cart_token: updatedCart.token,
      customer_id: CUSTOMER_ID,
      event_type: "add_to_cart",
      items: updatedCart.items.map(i => ({
        handle: i.handle,
        variant_id: i.variant_id,
        qty: i.quantity,
        price: i.price,
        title: i.product_title
      }))
    };

    fetch("https://shop-khangdopane.viveksaikhom.workers.dev",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body: JSON.stringify(payload)
    });

  }

});

})();